import { level, levelRules, linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { PRICE_SOURCE } from "../indicatorTypes";
import { priceReader } from "../math/priceSources";
import { highestAt, lowestAt } from "../math/windowExtremes";

const PERCENT = 100;

// Levels typed in the Styles tab, as in PO
const WILLIAMS_R_LEVEL_MIN = -100;
const WILLIAMS_R_LEVEL_MAX = 0;

/**
 * Williams %R (research §1.4), as TV Williams %R: the close against the
 * highest high of Period bars in percent of their high-low range, 0…−100.
 */
export default {
  id: "williams-r",
  name: "Williams %R",
  isOscillator: true,
  decimals: 2,
  inputs: [
    periodInput("period", "Period", 14, { max: 100 }),
  ],
  plots: [
    linePlot("value", "Main Line", PALETTE.AQUA),
  ],
  levels: [level(-20, PALETTE.LIME), level(-80, PALETTE.RED)],
  levelRules: levelRules(WILLIAMS_R_LEVEL_MIN, WILLIAMS_R_LEVEL_MAX),

  calculate: (bars, { period }, series, fromIndex) => {
    const readHigh = priceReader(bars, PRICE_SOURCE.HIGH);
    const readLow = priceReader(bars, PRICE_SOURCE.LOW);

    for (let index = fromIndex; index < bars.length; index += 1) {
      const highest = highestAt(readHigh, index, period);
      const lowest = lowestAt(readLow, index, period);

      series.value[index] = (PERCENT * (bars[index].close - highest)) / (highest - lowest);
    }
  },
};
